import { render, staticRenderFns } from "./RefugioPanel.vue?vue&type=template&id=642ee69c&scoped=true&lang=pug&"
import script from "./RefugioPanel.vue?vue&type=script&lang=js&"
export * from "./RefugioPanel.vue?vue&type=script&lang=js&"
import style0 from "./RefugioPanel.vue?vue&type=style&index=0&id=642ee69c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ee69c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VTab,VTabItem,VTabs})
